export const recordings = [
  // For large files, host externally (Google Drive, Dropbox, Cloudflare R2, etc.)
  // Then use the direct link here:
  // { id: 's01', title: 'Session 15', date: '2025-01-12', url: 'https://your-external-host.com/session-15.m4a', type: 'audio' },
  
  // Example external link (YouTube/Drive/etc.)
  // { id: 's02', title: 'Session 2 — The Serpent's Wake', date: '2025-01-26', url: 'https://youtu.be/xxxxxxxx', type: 'external' },
];
